import { useTranslation } from 'react-i18next';
import type { FunctionalDescriptionTranslationKeys } from '@/constants/basicPlan';

type FunctionalDescriptionProps = {
    items: FunctionalDescriptionTranslationKeys[];
};

function FunctionalDescription({ items }: FunctionalDescriptionProps) {
    const { t } = useTranslation('plans');

    return (
        <>
            {items.map((item, index) => (
                <div
                    key={item.titleKey}
                    className="flex flex-col lg:flex-row lg:items-center justify-center bg-kotomilThemaColorLight lg:min-h-[60vh] py-8 lg:py-10 px-4 lg:px-20 mx-2 lg:mx-0 my-4 rounded-xl"
                >
                    {/* 説明テキスト */}
                    <div className="lg:w-1/2 h-full flex flex-col pe-10 justify-center items-center text-center lg:text-left">
                        <h3 className="text-2xl lg:text-4xl leading-[1.8] lg:leading-[1.6] tracking-widest text-gray-800">
                            {t(item.titleKey)}
                        </h3>
                        <div
                            className="text-lg lg:text-2xl leading-[1.8] lg:leading-[1.6] mt-6 text-gray-700"
                            dangerouslySetInnerHTML={{
                                __html: t(item.descriptionKey, { interpolation: { escapeValue: false } }),
                            }}
                        />
                    </div>

                    {/* 画像 */}
                    <div className="mt-4 lg:mt-0 lg:w-1/2">
                        <img
                            src={item.image}
                            alt={t(item.imageAltKey)}
                            className="lg:1/2 rounded-xl image-protection"
                        />
                    </div>
                </div>
            ))}
        </>
    );
}

export default FunctionalDescription;
